import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./api/";
import Element from "element-ui";
import "./assets/css/mini-reset.css";
import "./assets/scss/index.scss";
import "./assets/css/global.css";

// import "~element-ui/packages/theme-chalk/src/index";
Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

// Vue.prototype.$IMG_URL = "http://192.168.16.25:31035/common/showPic?adress=";

console.log("env ", process.env);

Vue.prototype.$IMG_URL =
  process.env.NODE_ENV === "development"
    ? "http://192.168.16.25:31035/common/showPic?adress="
    : "https://ha.batar.cn/common/showPic?adress=";

Vue.prototype.$THUMB_Url =
  process.env.NODE_ENV === "development"
    ? "http://192.168.16.25:31035/common/thumbnailImage?adress="
    : "https://ha.batar.cn/common/thumbnailImage?adress=";

Vue.use(Element, { size: "mini" });
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
